{
  "app": {
    "name": "ATNT Конструктор",
    "loading": "Загрузка…"
  },
  "auth": {
    "title": "Вход в систему",
    "subtitle": "Платформа мониторинга водохранилищ",
    "login": "Логин",
    "loginPlaceholder": "Введите логин",
    "password": "Пароль",
    "passwordPlaceholder": "Введите пароль",
    "submit": "Войти",
    "logout": "Выйти",
    "showPassword": "Показать пароль",
    "hidePassword": "Скрыть пароль"
  },
  "common": {
    "save": "Сохранить",
    "cancel": "Отмена",
    "back": "Назад",
    "delete": "Удалить",
    "edit": "Редактировать",
    "add": "Добавить",
    "search": "Поиск",
    "preview": "Просмотр",
    "close": "Закрыть",
    "retry": "Повторить",
    "home": "Главная"
  },
  "errors": {
    "generic": "Произошла ошибка",
    "notFound": "Страница не найдена",
    "notFoundHint": "Страница не существует или у вас нет к ней доступа."
  }
}
